import React from "react";
import { IRoute } from "./utils";

const OrdersPage = React.lazy(() => import("../pages/OrdersPage"));
const OrdersRedirect = React.lazy(() => import("../pages/OrdersRedirect"));

export const orderRoutes:IRoute[] = [
    {
        path: "/",
        exact: true,
        component: OrdersPage,
        isPrivate: true,
    },
    {
        path: "/orders",
        exact: true,
        component: OrdersRedirect,
        isPrivate: false,
    }
]